module.exports = __webpack_public_path__ + "img/mrq.48195b97.png";